'use strict';

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./content.scss');
}

module.exports = {
    Contact:  require('./contact.jsx'),
    FAQ:      require('./faq.jsx'),
    Finance:  require('./finance.jsx'),
    Homepage: require('./homepage.jsx'),
    Landing:  require('./landing.jsx'),
};



// WEBPACK FOOTER //
// ./src/pages/content/content.jsx